module.exports = __webpack_public_path__ + "media/images/banner/tjt/sp/travel202309_06_1280_1280_th-56d443fa1e32b1813f85ca0dee197bda.jpg";